import plural from "plural-ru";

export function usePlural() {
  function pluralize(count, ...words) {
    return plural(count, ...words.map((w) => w));
  }

  return { pluralize };
}
